// import { createContext, useEffect, useState } from "react";

// export const DarkModeContext = createContext();

// // Context Provider, wraps entire application so that DarkModeContext can be accessed globally. 
// // Checks local storage for a darkMode variable. 
// // If there isn't a darkMode variable (ex. first time using application), then the value is set to false. 
// export const DarkModeContextProvider = ({ children }) => {
//   const [darkMode, setDarkMode] = useState(
//     JSON.parse(localStorage.getItem("darkMode")) || false
//   );

//   const toggle = () => {
//     setDarkMode(!darkMode);
//   };

//   // If first visit, writes a variable in local storage. 
//   // Whenever darkMode value changes, local storage will be set again with new value
//   useEffect(() => {
//     localStorage.setItem("darkMode", darkMode);
//   }, [darkMode]);

//   return (
//     <DarkModeContext.Provider value={{ darkMode, toggle }}>
//       {children}
//     </DarkModeContext.Provider>
//   );
// };




import { createContext, useEffect, useState } from "react";

export const DarkModeContext = createContext();

// Context provider, wraps the entire app
export const DarkModeContextProvider = ({ children }) => {
  const [darkMode, setDarkMode] = useState(
    JSON.parse(localStorage.getItem("darkMode")) || false
  );

  const toggle = () => {
    setDarkMode(!darkMode);
  };

  // Persist darkMode in localStorage
  useEffect(() => {
    localStorage.setItem("darkMode", darkMode);
  }, [darkMode]);

  // 🔥 NEW: update <meta name="theme-color"> dynamically
  useEffect(() => {
    let themeMeta = document.querySelector("meta[name='theme-color']");
    if (!themeMeta) {
      themeMeta = document.createElement("meta");
      themeMeta.name = "theme-color";
      document.head.appendChild(themeMeta);
    }
    themeMeta.setAttribute("content", darkMode ? "#000000" : "#ffffff");
  }, [darkMode]);

  // Set body and html background color based on theme to fix overscroll white background
  useEffect(() => {
    const bgColor = darkMode ? "#333" : "#f6f3f3";
    document.body.style.backgroundColor = bgColor;
    document.documentElement.style.backgroundColor = bgColor;
    return () => {
      document.body.style.backgroundColor = '';
      document.documentElement.style.backgroundColor = '';
    };
  }, [darkMode]);

  return (
    <DarkModeContext.Provider value={{ darkMode, toggle }}>
      {children}
    </DarkModeContext.Provider>
  );
};

